var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height"},[_c('div',{attrs:{"id":"onlyoffice_viewer"}}),_vm._v(" "),(_vm.error)?_c('ErrorAlert',{attrs:{"error":_vm.error}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }